import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'partner-registry-grid',
    components: {

    },
})
export default class PartnerRegistryGrid extends Vue {

    @Prop({default: {}})
    private content: any;

    private partnerNames = {
        content_developers : 'Content Partners',
        lab_schools: 'eLearning Providers',
        schools: 'eLearning Providers',
        integration_partners: 'EdTech Companies',
        researchers: 'Researchers',
        funders: 'Funders',
    };

    private showDeatils(content: any) {
        this.$emit('showDeatils', content);
    }

}
